import { Route, Redirect } from "react-router-dom";
import React from "react";
import { store } from '../../../redux/store';

const PublicRoute = ({ component: Component, ...rest }) => {
  const state = store.getState();
  console.log(state);
  return (
    <Route
      {...rest}
      render={(props) => {
        if (state && state.userData && state.userData.token) {
          return (
            <Redirect
              to={{
                pathname: rest.redirectRoute,
                extras: { ...rest.location },
              }}
            />
          );
        } else {
          return <Component {...props} />;
        }
      }}
    />
  );
};

export default PublicRoute;
